/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyPatchPharmacyListImage,
  PharmacyPatchPharmacyListImageFromJSON,
  PharmacyPatchPharmacyListImageFromJSONTyped,
  PharmacyPatchPharmacyListImageToJSON,
} from "./";

export const PatchPharmacyListImagesRequestBodyTypename = "PatchPharmacyListImagesRequestBody" as const;

/**
 *
 * @export
 * @interface PatchPharmacyListImagesRequestBody
 */
export interface PatchPharmacyListImagesRequestBody {
  /**
   *
   * @type {Array<PharmacyPatchPharmacyListImage>}
   * @memberof PatchPharmacyListImagesRequestBody
   */
  listImageData?: Array<PharmacyPatchPharmacyListImage>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatchPharmacyListImagesRequestBody
   */
  readonly __typename?: string;
}

export function PatchPharmacyListImagesRequestBodyFromJSON(json: any): PatchPharmacyListImagesRequestBody {
  return PatchPharmacyListImagesRequestBodyFromJSONTyped(json, false);
}

export function PatchPharmacyListImagesRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchPharmacyListImagesRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatchPharmacyListImagesRequestBodyTypename,

    listImageData: !exists(json, "list_image_data")
      ? undefined
      : (json["list_image_data"] as Array<any>).map(PharmacyPatchPharmacyListImageFromJSON),
  };
}

export function PatchPharmacyListImagesRequestBodyToJSON(object?: PatchPharmacyListImagesRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    list_image_data:
      value.listImageData === undefined
        ? undefined
        : (value.listImageData as Array<any>).map(PharmacyPatchPharmacyListImageToJSON),
  };
}
